import angular from 'angular';
import ComponentsModule from '../components-module';
import Debug from 'ace-ui/ace-debug';

const COMPONENT_NAME = 'Progress';
const debug = new Debug (COMPONENT_NAME);

angular.module(ComponentsModule)
  .factory (COMPONENT_NAME, () => {
    return class {
      constructor () {
        debug.log ('New Progress! ----');
        this._count = 0;
        this._progressives = {};
      }

      increment (id) {
        this._progressives[id] ? this._progressives[id]++ : this._progressives[id] = 1;
        debug.log(`Progress added ${id}`, this._progressives);
      }
      decrement (id) {
        this._progressives[id] ? this._progressives[id]-- : this._progressives[id] = 0;
        if (!this._progressives[id]) {
          delete this._progressives[id];
        }
        debug.log(`Progress removed ${id}`, this._progressives);
      }
      check (debug) {
        if (debug) {
          console.log(this._progressives);
        }
        for (let id in this._progressives) {
          if (this._progressives[id]) {
            return true;
          }
        }
        return false;
      }

      get is () {
        return this.check();
      }
    };
  });

export default COMPONENT_NAME;